import { Component, ElementRef, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NameplateItem, NameplateService } from '../../../services/nameplates/nameplate.service';
import { MessengerService } from '../../../services/messenger/messenger.service';
import { ChatService } from '../../../services/chat/chat.service';
import { PortraitService } from '../../../services/portraits/portrait.service';

@Component({
  selector: 'app-nameplate-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './nameplate-modal.html',
  styleUrl: './nameplate-modal.scss',
})
export class NameplateModal implements OnInit {
  private nameplateService = inject(NameplateService);
  private messengerService = inject(MessengerService);
  private chatService = inject(ChatService);
  private portraitService = inject(PortraitService);
  private el = inject(ElementRef);

  public currentUser = this.messengerService.currentUser;
  public nameplates = this.nameplateService.ownedNameplates;

  public selectedNameplate = signal<any | null>(null);
  public activeNameplateId = signal<number>(0);

  ngOnInit() {
    this.nameplateService.getOwned().subscribe();

    if (this.nameplates().length > 0) {
      this.selectedNameplate.set(this.nameplates()[0]);
    }

    const modalEl = this.el.nativeElement.querySelector('#nameplateChangeModal');
    if (modalEl) {
      modalEl.addEventListener('show.bs.modal', () => {
        this.onModalOpen();
      });
    }
  }

  onModalOpen() {
    this.nameplateService.getOwned().subscribe({
      next: (owned: any[]) => {
        const list = this.nameplates();
        if (list && list.length > 0) {
          const activeItem = list.find((np: any) => np.active);
          if (activeItem) {
            this.selectedNameplate.set(activeItem);
          } else {
            this.selectedNameplate.set(list[0]);
          }
        }
      }
    });
  }

  selectNameplate(np: any) {
    this.selectedNameplate.set(np);
  }

  saveNameplate() {
    const np = this.selectedNameplate();
    const id = np ? (np.nameplateId ?? np.nameplate?.id ?? np.id ?? 0) : 0;
    const bgStyle = np?.nameplate?.backgroundUrl || np?.backgroundStyle || '';

    this.nameplateService.update(id).subscribe({
      next: () => {
        this.nameplateService.getOwned().subscribe();
        this.chatService.updateUser();
        this.messengerService.updateUser();
        this.portraitService.getMine().subscribe({
          next: (res: any) => {
            if (res) {
              this.messengerService.setMe(res);
            }
          }
        });
      },
      error: (err) => {
        console.error('Failed to update nameplate', err);
      }
    });

    const meSignal = (this.messengerService as any).me;
    if (meSignal) {
      meSignal.update((curr: any) => ({
        ...curr,
        backgroundUrl: bgStyle
      }));
    }
    this.activeNameplateId.set(id);
  }
}
